import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class LandingLogoItem extends BaseModel {
  static override constructorName = 'LandingLogoItem'

  _index: string = ''
  item: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['item'])

      this.item = toCroppedImage(data.item)
    }
  }
}
